import {
  CreateSourceWikipediaAction,
  CreateSourceWikipediaActionType,
  SetCrawlDepthAction,
  SetErrorAction,
  SetLinksPerPageAction,
  SetMaxPagesAction,
  SetPhaseAction,
  SetSeedUrlAction,
  SetShouldShowErrorsAction,
  SetSourceNameAction,
} from "@/pages/sources/components/create/sources/wikipedia/actions";
import {
  CreateSourceWikipediaPhase,
  CreateSourceWikipediaState,
} from "@/pages/sources/components/create/sources/wikipedia/types";

function setSourceName(
  state: CreateSourceWikipediaState,
  action: SetSourceNameAction,
): CreateSourceWikipediaState {
  return { ...state, sourceName: action.payload };
}

function setSeedUrl(
  state: CreateSourceWikipediaState,
  action: SetSeedUrlAction,
): CreateSourceWikipediaState {
  return { ...state, seedUrl: action.payload };
}

function setLinksPerPage(
  state: CreateSourceWikipediaState,
  action: SetLinksPerPageAction,
): CreateSourceWikipediaState {
  return { ...state, linksPerPage: action.payload };
}

function setCrawlDepth(
  state: CreateSourceWikipediaState,
  action: SetCrawlDepthAction,
): CreateSourceWikipediaState {
  return { ...state, crawlDepth: action.payload };
}

function setMaxPages(
  state: CreateSourceWikipediaState,
  action: SetMaxPagesAction,
): CreateSourceWikipediaState {
  return { ...state, maxPages: action.payload };
}

function setPhase(
  state: CreateSourceWikipediaState,
  action: SetPhaseAction,
): CreateSourceWikipediaState {
  return {
    ...state,
    phase: action.payload,
    error: action.payload === CreateSourceWikipediaPhase.ERROR ? state.error : null,
  };
}

function setError(
  state: CreateSourceWikipediaState,
  action: SetErrorAction,
): CreateSourceWikipediaState {
  return {
    ...state,
    error: action.payload,
    phase: action.payload ? CreateSourceWikipediaPhase.ERROR : state.phase,
  };
}

function setShouldShowErrors(
  state: CreateSourceWikipediaState,
  action: SetShouldShowErrorsAction,
): CreateSourceWikipediaState {
  return { ...state, shouldShowErrors: action.payload };
}

const createSourceWikipediaReducer = (
  state: CreateSourceWikipediaState,
  action: CreateSourceWikipediaAction,
): CreateSourceWikipediaState => {
  switch (action.type) {
    case CreateSourceWikipediaActionType.SET_SOURCE_NAME:
      return setSourceName(state, action);
    case CreateSourceWikipediaActionType.SET_SEED_URL:
      return setSeedUrl(state, action);
    case CreateSourceWikipediaActionType.SET_LINKS_PER_PAGE:
      return setLinksPerPage(state, action);
    case CreateSourceWikipediaActionType.SET_CRAWL_DEPTH:
      return setCrawlDepth(state, action);
    case CreateSourceWikipediaActionType.SET_MAX_PAGES:
      return setMaxPages(state, action);
    case CreateSourceWikipediaActionType.SET_PHASE:
      return setPhase(state, action);
    case CreateSourceWikipediaActionType.SET_ERROR:
      return setError(state, action);
    case CreateSourceWikipediaActionType.SET_SHOULD_SHOW_ERRORS:
      return setShouldShowErrors(state, action);
  }
};

export default createSourceWikipediaReducer;
